import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon(/*#__PURE__*/ _jsx("path", {
    fill: "currentColor",
    d: "M12 13a1.4895 1.4895 0 0 0-1.4088.9568A1.49 1.49 0 0 0 11 15.61V17a1.0001 1.0001 0 0 0 2 0v-1.39a1.49 1.49 0 0 0 .4088-1.6532A1.49 1.49 0 0 0 12 13m5-4V7A5 5 0 0 0 7 7v2a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3M9 7a3 3 0 1 1 6 0v2H9zm9 12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1z"
}), "Lock", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
